import { createFileRoute } from '@tanstack/react-router'
import { userSearchSchema } from '../../../features/admin/search'
import { UsersListPage } from '../../../features/admin/users-list-page'

export const Route = createFileRoute('/_app/users/')({
  validateSearch: userSearchSchema,
  component: UsersListPage,
})
